export enum AuthCookies {
    REDIRECT_URI = "redirect_uri"
}